module.exports = __webpack_public_path__ + "img/curved10.cf37b5ad.jpg";